import React, { useState } from "react";
import CloseSvg from "../../../../../assets/svgs/CloseSvg";
import CommunityVisitRulesFilter from "../components/CommunityVisitRulesFilter";
import CommunityVisitRulesTable from "../components/CommunityVisitRulesTable";
import Pagination from "../../../../../components/Pagination/Pagination";

const CommunityVisitRules = ({
  rules,
  handleCommunityVisitRulesModal,
  constraintToEdit,
  setConstraintToEdit,
  setVisitRules,
  isWelcomePage,
  count,
  fetchConstraints,
  setSearch,
  search,
  setFrequencyFilter,
  frequencyFilter,
  setAvailabilityFilter,
  availabilityFilter,
}) => {
  // const [nameFilter, setNameFilter] = useState("");
  // const [frequencyFilter, setrequencyFilter] = useState([]);
  // const [AvailabilityFilter, setAvailabilityFilter] = useState([]);

  const handleNameFilter = (name) => {
    setSearch(name);
  };

  const handleFrequencyFilter = (frequency) => {
    if (frequencyFilter.includes(frequency)) {
      setFrequencyFilter(
        frequencyFilter.filter((filter) => filter !== frequency)
      );
    }
    if (!frequencyFilter.includes(frequency)) {
      setFrequencyFilter([...frequencyFilter, frequency]);
    }
  };
  const handleAvailabilityFilter = (Availability) => {
    if (availabilityFilter.includes(Availability)) {
      setAvailabilityFilter(
        availabilityFilter.filter((filter) => filter !== Availability)
      );
    }

    if (!availabilityFilter.includes(Availability)) {
      setAvailabilityFilter([...availabilityFilter, Availability]);
    }
  };

  const handleEditClick = (constraint) => {
    if (constraintToEdit) {
      setConstraintToEdit(null);
    } else {
      setConstraintToEdit(constraint);
    }
  };

  // const filterCommunityVisitRules = (rule) => {
  //   const nameMatch = rule.name
  //     .toLowerCase()
  //     .includes(search.toLowerCase());
  //   const frequencyMatch = frequencyFilter.includes(rule.frequency);

  //   let AvailabilityMatch = false;

  //   availabilityFilter.forEach((day) => {
  //     if (!AvailabilityMatch) {
  //       AvailabilityMatch = rule.visitDays.includes(day.toUpperCase());
  //     }
  //   });

  //   return (
  //     nameMatch &&
  //     (availabilityFilter.length === 0 || AvailabilityMatch) &&
  //     (frequencyFilter.length === 0 || frequencyMatch)
  //   );
  // };

  return (
    <>
      <div
        className={`max-h-screen ${isWelcomePage ? "py-2" : "p-4 "
          } overflow-hidden`}
      >
        <div className="flex  w-full gap-2 mb-4">
          <div className="flex flex-row items-center justify-between">
            <div className="m-0 text-lg font-bold w-44">
               {count} record
              {count > 1 && "s"}
            </div>
          </div>
          <CommunityVisitRulesFilter
            handleNameFilter={handleNameFilter}
            handleFrequencyFilter={handleFrequencyFilter}
            handleAvailabilityFilter={handleAvailabilityFilter}
            nameFilter={search}
            frequencyFilter={frequencyFilter}
            AvailabilityFilter={availabilityFilter}
            isWelcomePage={isWelcomePage}
          />
        </div>
        <div className="w-full px-16">
          <Pagination count={count} api={fetchConstraints} />
        </div>
        <CommunityVisitRulesTable
          rules={rules}
          handleEditClick={handleEditClick}
          setVisitRules={setVisitRules}
          isWelcomePage={isWelcomePage}
        />
      </div>
    </>
  );
};

export default CommunityVisitRules;
